import { toHex } from 'viem';
export async function updateAppPermissions(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { appAddress, permissions, signer, appId, clientAddress } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for updateAppPermissions operation.');
    }
    const simpleApp = appRegistryDapp.callApp(appAddress);
    const updatePermissions = simpleApp.interface.encodeFunctionData('updatePermissions', [
        permissions.map((p) => toHex(p, { size: 32 })),
    ]);
    const upgradeApp = appRegistryDapp.registry.interface.encodeFunctionData('upgradeApp', [
        appAddress,
        clientAddress,
        appId,
    ]);
    return smartAccount.sendUserOp({
        toAddress: [appAddress, appRegistryDapp.registry.address],
        callData: [updatePermissions, upgradeApp],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
